module.exports = __webpack_public_path__ + "img/trivia846.9210c5d6.jpg";